const isNullOrUndefined = (value)=>value === null || value === undefined;

export { isNullOrUndefined };
